module.exports = __webpack_public_path__ + "img/SC-PROOF-4799.733cef53.png";